import type { Scene, SceneLayerKey, SceneLayerState, Token } from "../types";

export const SCENE_LAYER_ORDER: SceneLayerKey[] = ["gm", "foreground", "tokens", "fog", "lighting", "terrain", "background"];
export const SCENE_LAYER_LABELS: Record<SceneLayerKey, string> = {
  background: "Map background", terrain: "Terrain & weather", tokens: "Tokens", foreground: "Foreground props", lighting: "Lighting", fog: "Fog of war", gm: "DM notes",
};

const DEFAULT_STATE: SceneLayerState = { visible: true, locked: false };

export function sceneLayerState(scene: Scene, layer: SceneLayerKey): SceneLayerState {
  return { ...DEFAULT_STATE, ...scene.layers?.[layer] };
}

export function updateSceneLayer(scene: Scene, layer: SceneLayerKey, patch: Partial<SceneLayerState>): Scene {
  return { ...scene, layers: { ...scene.layers, [layer]: { ...sceneLayerState(scene, layer), ...patch } }, updatedAt: Date.now() };
}

export function tokenLayer(token: Token): "tokens" | "foreground" | "gm" {
  return token.layer ?? (token.effect ? "foreground" : "tokens");
}

export function sceneObjectLocked(scene: Scene, kind: "token" | "wall" | "object-wall" | "portal" | "light" | "water" | "weather-dry" | "material" | "physical-object" | "map-pin" | "area-template", id: string): boolean {
  if (kind === "token") { const token = scene.tokens.find((item) => item.id === id); return Boolean(token?.locked || (token && sceneLayerState(scene, tokenLayer(token)).locked)); }
  if (kind === "light") return Boolean(scene.geometry?.lights.find((item) => item.id === id)?.locked || sceneLayerState(scene, "lighting").locked);
  if (kind === "wall" || kind === "object-wall" || kind === "portal") {
    const list = kind === "wall" ? scene.geometry?.walls : kind === "object-wall" ? scene.geometry?.objectWalls : scene.geometry?.portals;
    return Boolean(list?.find((item) => item.id === id)?.locked || sceneLayerState(scene, "lighting").locked);
  }
  if (kind === "water") return Boolean(scene.waterRegions?.find((item) => item.id === id)?.locked || sceneLayerState(scene, "terrain").locked);
  if (kind === "material") return Boolean(scene.materialRegions?.find((item) => item.id === id)?.locked || sceneLayerState(scene, "terrain").locked);
  if (kind === "physical-object") return Boolean(scene.physicalObjects?.find((item) => item.id === id)?.locked || sceneLayerState(scene, "gm").locked);
  if (kind === "map-pin" || kind === "area-template") return sceneLayerState(scene, "gm").locked;
  return Boolean(scene.weatherDryRegions?.find((item) => item.id === id)?.locked || sceneLayerState(scene, "terrain").locked);
}
